export default {
 pageTitle: 'Business Services',
 heroDesc: 'One-stop cross-border business services to help enterprises develop globally',
 featuresTitle: 'Service Features',
 featuresSubtitle: 'Professional, efficient, and comprehensive business services',
 feature1Title: 'Global Network',
 feature1Desc: 'Service network covering 50+ countries and regions',
 feature2Title: 'Professional Team',
 feature2Desc: 'Experienced professional service team',
 feature3Title: 'One-Stop Service',
 feature3Desc: 'Full-process service from registration to operation',
 feature4Title: 'Efficient & Convenient',
 feature4Desc: 'Quick response, efficient handling of all business',
 purposeTitle: 'Service Objectives',
 purposePara1: 'The purpose of international business solutions is to use our overseas legal and business service networks to help clients solve legal and operational difficulties that may arise in cross-border business activities.',
 purposePara2: 'We are committed to reducing corporate operating costs, avoiding risks, eliminating the risk of reduced property returns caused by political, economic, and cultural factors, and escorting the global development of enterprises.',
 viewDetails: 'View Details',
 service1Title: 'Company Registration and Management',
 service1Subtitle: 'Global Business Organization Setup and Management',
 service1Desc: 'We can provide setup and management services for business organizations such as limited companies, partnerships, and branches in Hong Kong, Macao, Singapore, British Virgin Islands, Samoa, Seychelles, British Anguilla, Bahamas, Panama, Cayman Islands, Bermuda, USA, Philippines, Malaysia, Myanmar, etc.',
 service1Feature1Title: 'Company Setup Services',
 service1Feature1Item1: 'Company setup in Hong Kong, Macao, and Singapore',
 service1Feature1Item2: 'Offshore companies in British Virgin Islands, Samoa, and Seychelles',
 service1Feature1Item3: 'Companies in Cayman Islands, Bermuda, Bahamas, and Panama',
 service1Feature1Item4: 'Company setup in various states of the USA',
 service1Feature1Item5: 'Companies in Southeast Asia such as the Philippines, Malaysia, and Myanmar',
 service1Feature1Item6: 'Setup of limited companies, partnerships, and branches',
 service1Feature2Title: 'Company Management Services',
 service1Feature2Item1: 'Optimization plans for company structure and internal governance',
 service1Feature2Item2: 'Drawing, management, and updating of ownership chains in organizational structures',
 service1Feature2Item3: 'Handling of various company documents and signatures',
 service1Feature2Item4: 'Procedures for company changes and filings',
 service1Feature2Item5: 'Company liquidation and dissolution services',
 service1Feature2Item6: 'Procedures for equity pledges and other related matters',
 service2Title: 'Bank Account',
 service2Subtitle: 'Global Bank Account Opening and Financial Services',
 service2Desc: 'Through cooperation with multiple large and well-known commercial banks and private banks globally, we provide services such as pre-account opening appointments, business plan drafting, document verification, and accompanying face-to-face signing for clients, providing consulting opinions on capital financing, avoiding foreign exchange risks, and selecting financial tools.',
 service2Feature1Title: 'Bank Account Opening Services',
 service2Feature1Item1: 'Pre-account opening appointment services',
 service2Feature1Item2: 'Business plan drafting',
 service2Feature1Item3: 'Document verification and accompanying face-to-face signing',
 service2Feature1Item4: 'Bank account opening services in mainland China',
 service2Feature1Item5: 'Mainstream bank account opening in Hong Kong',
 service2Feature1Item6: 'Bank account opening in Singapore',
 service2Feature1Item7: 'Bank account opening in the USA',
 service2Feature1Item8: 'Bank account opening in the Philippines, Malaysia, and Myanmar',
 service2Feature2Title: 'Financial Consulting Services',
 service2Feature2Item1: 'Consulting on capital financing',
 service2Feature2Item2: 'Schemes to avoid foreign exchange risks',
 service2Feature2Item3: 'Consulting on selecting financial tools',
 service2Feature2Item4: 'Cross-border fund management',
 service2Feature2Item5: 'Connecting with private bank services',
 service2Feature2Item6: 'Arranging commercial bank services',
 service3Title: 'Accounting & Audit',
 service3Subtitle: 'Professional Tax and Audit Services',
 service3Desc: 'Relying on our overseas audit team and cooperating institutions, we provide accounting, audit, and tax services to clients, helping them to propose tax opposition opinions, optimize cross-border financial management methods, avoid tax and accounting risks, and provide consulting opinions and training based on differences in accounting standards.',
 service3Feature1Title: 'Accounting & Audit Services',
 service3Feature1Item1: 'Professional accounting services',
 service3Feature1Item2: 'Annual audit services',
 service3Feature1Item3: 'Tax services',
 service3Feature1Item4: 'Compliance review',
 service3Feature1Item5: 'Compilation of financial statements',
 service3Feature2Title: 'Tax and Accounting Consulting Services',
 service3Feature2Item1: 'Proposing tax opposition opinions',
 service3Feature2Item2: 'Optimizing cross-border financial management methods',
 service3Feature2Item3: 'Avoiding tax and accounting risks',
 service3Feature2Item4: 'Consulting on differences in accounting standards',
 service3Feature2Item5: 'Tax and accounting training services',
 service4Title: 'Company Search',
 service4Subtitle: 'Company Information Inquiry and Document Verification',
 service4Desc: 'We provide company existence and legality search services as well as legal document verification services, allowing for comprehensive inquiries of local companies.',
 service4Feature1Title: 'Basic Company Information Inquiry',
 service4Feature1Item1: 'Company establishment date',
 service4Feature1Item2: 'Registration certificate number',
 service4Feature1Item3: 'Names and addresses of directors and shareholders',
 service4Feature1Item4: 'Names and addresses of company statutory secretaries',
 service4Feature1Item5: 'Company registered address',
 service4Feature1Item6: 'Company registered capital',
 service4Feature2Title: 'Company Document Verification',
 service4Feature2Item1: 'Copies of company articles of association',
 service4Feature2Item2: 'Certificates of good standing of the company',
 service4Feature2Item3: 'Certificates of registered agents',
 service4Feature2Item4: 'Annual return forms',
 service4Feature2Item5: 'Other relevant legal documents',
 service5Title: 'Cross-border Investment',
 service5Subtitle: 'Comprehensive Cross-border Investment Services',
 service5Desc: 'Cross-border investment services not only include offshore legal services but also provide investment strategy plans, comprehensive due diligence, bank services and financing plans, tax plans, cross-border merger and acquisition structure setup, etc.',
 service5Feature1Title: 'Investment Strategy and Due Diligence',
 service5Feature1Item1: 'Formulation of investment strategy plans',
 service5Feature1Item2: 'Legal due diligence',
 service5Feature1Item3: 'Policy due diligence',
 service5Feature1Item4: 'Financial due diligence',
 service5Feature1Item5: 'Tax due diligence',
 service5Feature1Item6: 'Investigation of labor, religion, and logistics',
 service5Feature2Title: 'Investment Implementation Services',
 service5Feature2Item1: 'Bank services and financing plans',
 service5Feature2Item2: 'Tax plans',
 service5Feature2Item3: 'Cross-border merger and acquisition structure setup',
 service5Feature2Item4: 'Arrangement of financing structures',
 service5Feature2Item5: 'Schemes for the use of free trade zones',
 service5Feature2Item6: 'Business trips and travel arrangements',
 service6Title: 'International Tax Planning and Overseas Tax Opposition',
 service6Subtitle: 'Professional Tax Planning and Opposition Services',
 service6Desc: 'During the process of enterprises investing and developing overseas, they must have a deeper understanding of the tax policies of the investment and trade countries. LEVIY provides clients with the most comprehensive tax policy analysis, helping enterprises to reasonably allocate capital and profits between branches and subsidiaries in different parts of the world in cross-border operations.',
 service6Feature1Title: 'International Tax Planning',
 service6Feature1Item1: 'Analysis of tax policies in investment and trade countries',
 service6Feature1Item2: 'Capital allocation plans for global branches',
 service6Feature1Item3: 'Optimization of profit allocation',
 service6Feature1Item4: 'Schemes to reduce enterprise costs',
 service6Feature1Item5: 'Planning for profit retention and appreciation',
 service6Feature2Title: 'Overseas Tax Opposition',
 service6Feature2Item1: 'Identification of unreasonable taxes',
 service6Feature2Item2: 'Arrangement of professional lawyers and tax advisors',
 service6Feature2Item3: 'Proposing tax opposition',
 service6Feature2Item4: 'Reclaiming corresponding taxes',
 service6Feature2Item5: 'Resolution of tax disputes',
 service7Title: 'International Business Solutions',
 service7Subtitle: 'Comprehensive Business Solutions',
 service7Desc: 'Based on the needs of clients in overseas investment and service, we formulate comprehensive business solutions for clients, including legal verification of investment and trade destinations, verification of human and local social culture, verification of government operation methods, enterprise strategic planning, brand planning, tax planning, and asset planning.',
 service7Feature1Title: 'Pre-investment Research and Planning',
 service7Feature1Item1: 'Legal verification of investment and trade destinations',
 service7Feature1Item2: 'Verification of human and local social culture',
 service7Feature1Item3: 'Verification of government operation methods',
 service7Feature1Item4: 'Enterprise strategic planning',
 service7Feature1Item5: 'Brand planning',
 service7Feature1Item6: 'Tax planning and asset planning',
 service7Feature2Title: 'Risk Avoidance and Protection',
 service7Feature2Item1: 'Enterprise risk avoidance planning',
 service7Feature2Item2: 'Planning for shareholder and director income risks',
 service7Feature2Item3: 'Strategic planning for enterprise income risks',
 service7Feature2Item4: 'Arrangement of insurance services',
 service7Feature2Item5: 'Private bank services',
 service7Feature2Item6: 'Commercial bank services',
}
